<template>
  <div class="page flex-col">
    <div class="block_1 flex-col">
      <div class="section_1 flex-col">
        <div class="block_2 flex-col">
          <div class="box_1 flex-row">
            <img
              class="label_1"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
            />
            <img
              class="image_1"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG33f935e7aff511ef96bc22348410d09b.png')"
            />
            <span class="text_1">首页</span>
            <span class="text_2">解决方案</span>
            <span class="text_3">康复助手</span>
            <span class="text_4">产品介绍</span>
            <img
              class="thumbnail_1"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG6ade881850d426babafbd1f786171d99.png')"
            />
            <span class="text_5">功能及报价</span>
            <span class="text_6">关于我们</span>
            <div class="box_2 flex-row">
              <span class="text_7">登录</span>
              <div class="block_3 flex-col"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block_4 flex-col">
      <div class="box_3 flex-row justify-between">
        <div class="section_2 flex-col"></div>
        <span class="text_8">以动健康</span>
        <div class="section_3 flex-col"></div>
      </div>
      <span class="text_9">以运动处方科技助力健康</span>
      <span class="paragraph_1">
        生活方式干预治疗，尤其是运动处方治疗慢病已经是国策-“体医融合”。运动处方服务增加收入，增加新的研究方向和提高慢病干预管理效果。但目前没有相关运动处方权威数据库得到广泛认可。
        <br />
        我们通过运动处方工作站，搭载运动处方数据库软件销售给需要运动处方干预的场所和个人，并且配置物联网化的运动设备和国际培训课程，全面设置场景，赋予工具给各级医院、养老地产、国民体质监测中心等。
        <br />
        创始团队来自国家体医融合中心核心团队，北京大学第一医院和美国顶尖权威专家，深谙体医融合政策和技术，并具有多年网络数据库和物联网设备开发经验。公司已经与国内北京大学第一医院，北京医院等多家三甲医院以及国家的科研机构合作承接多个重大专项。产品相关论文发表三篇，获得多家科研机构和企业订单。
      </span>
      <div class="box_4 flex-col">
        <div class="block_5 flex-row">
          <div class="box_5 flex-col"></div>
          <div class="box_6 flex-col"></div>
          <div class="box_7 flex-col"></div>
          <div class="box_8 flex-col"></div>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
          />
          <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
          />
          <img
            class="thumbnail_4"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
          />
          <span class="text_10">团队介绍</span>
        </div>
        <div class="block_6 flex-row justify-between">
          <div class="group_1 flex-row">
            <div class="section_4 flex-col"></div>
            <div class="section_5 flex-col justify-between">
              <div class="text-group_1 flex-col justify-between">
                <span class="text_11">郭威</span>
                <span class="text_12">创始人/总经理</span>
              </div>
              <div class="group_2 flex-col"></div>
            </div>
            <div class="text-wrapper_1 flex-col">
              <span class="text_13">手机：13220190868</span>
              <span class="text_14">邮箱：info&#64;ktangtang.com</span>
              <span class="text_15">学历：硕士</span>
              <span class="text_16">毕业学校：纽约大学</span>
              <span class="paragraph_2">
                拥有物理治疗硕士学位，是从WCPT国际物
                <br />
                理治疗师联盟主席&nbsp;Dr.Marilyn&nbsp;Moffat&nbsp;及中
                <br />
                华康复医学会原副会长，云南省康复医学会
                <br />
                会长敖丽娟
              </span>
            </div>
          </div>
          <div class="group_3 flex-col justify-between">
            <div class="section_6 flex-row">
              <div class="block_7 flex-col">
                <div class="box_9 flex-row">
                  <div class="group_4 flex-col"></div>
                  <img
                    class="image_2"
                    referrerpolicy="no-referrer"
                    v-lazy="require('./assets/img/FigmaDDSSlicePNGcedc9cad2b62f890f3613a4d994e8643.png')"
                  />
                </div>
              </div>
              <div class="block_8 flex-col">
                <div class="group_5 flex-row justify-between">
                  <div class="block_9 flex-row">
                    <div class="box_10 flex-col"></div>
                    <span class="text_17">Marilyn&nbsp;Moffat</span>
                  </div>
                  <div class="block_10 flex-col"></div>
                  <span class="text_18">技术顾问</span>
                </div>
                <div class="group_6 flex-row justify-between">
                  <div class="group_7 flex-col"></div>
                  <div class="group_8 flex-col"></div>
                  <span class="text_19">纽约大学终身教授</span>
                </div>
                <div class="group_9 flex-row justify-between">
                  <div class="section_7 flex-col"></div>
                  <div class="section_8 flex-col"></div>
                  <span class="text_20">国际物理治疗师联盟新卸任主席</span>
                </div>
                <div class="group_10 flex-row justify-between">
                  <div class="group_11 flex-col"></div>
                  <div class="group_12 flex-col"></div>
                  <span class="text_21">美国物理治疗师联盟前主席</span>
                </div>
                <div class="group_13 flex-row">
                  <div class="box_11 flex-col"></div>
                  <div class="box_12 flex-col"></div>
                  <span class="text_22">负责公司医学技术及相关数据库研发咨询，培训，高新技术转让</span>
                </div>
              </div>
            </div>
            <div class="section_9 flex-row">
              <div class="group_14 flex-col">
                <div class="section_10 flex-row">
                  <div class="box_13 flex-col"></div>
                  <img
                    class="image_3"
                    referrerpolicy="no-referrer"
                    v-lazy="require('./assets/img/FigmaDDSSlicePNGe19403e86ef04d13e36aa9b8aa36b759.png')"
                  />
                </div>
              </div>
              <div class="group_15 flex-col justify-between">
                <div class="group_16 flex-row justify-between">
                  <div class="text-wrapper_2 flex-col"><span class="text_23">Dr.Karen&nbsp;Kemmis</span></div>
                  <span class="text_24">技术顾问</span>
                </div>
                <div class="group_17 flex-row justify-between">
                  <div class="section_11 flex-col">
                    <div class="group_18 flex-col"></div>
                    <div class="group_19 flex-col"></div>
                    <div class="group_20 flex-col"></div>
                  </div>
                  <div class="text-group_2 flex-col justify-between">
                    <span class="paragraph_3">
                      世界上历史最悠久的糖尿病研究中心
                      <br />
                      哈佛大学Joslin糖尿病研究中心的主管治疗师
                    </span>
                    <span class="text_25">美国糖尿病教育协会现主席</span>
                    <span class="text_26">产品逻辑设计顾问</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block_11 flex-row justify-between">
          <div class="section_12 flex-row">
            <div class="image-wrapper_1 flex-col">
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG4994564ff8beadbb354a02357ab27d75.png')"
              />
            </div>
            <div class="group_21 flex-col justify-between">
              <div class="box_14 flex-row justify-between">
                <div class="text-wrapper_3 flex-col"><span class="text_27">马兖</span></div>
                <span class="text_28">特聘专家</span>
              </div>
              <div class="box_15 flex-row justify-between">
                <div class="group_22 flex-col justify-between">
                  <div class="block_12 flex-col"></div>
                  <div class="block_13 flex-col"></div>
                  <div class="block_14 flex-col"></div>
                </div>
                <div class="text-group_3 flex-col justify-between">
                  <span class="text_29">北京体育大学博士研究生</span>
                  <span class="text_30">拥有五年以上网络应用项目研发经验</span>
                  <span class="text_31">2022北京冬奥会赛前心理科技服务课题负责人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="section_13 flex-row">
            <div class="image-wrapper_2 flex-col">
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNGf3a3a2e6f295df3289eeea2b3ac9936f.png')"
              />
            </div>
            <div class="box_16 flex-col justify-between">
              <div class="block_15 flex-row justify-between">
                <div class="text-wrapper_4 flex-col"><span class="text_32">何铁强</span></div>
                <span class="text_33">产业顾问</span>
              </div>
              <div class="block_16 flex-row justify-between">
                <div class="box_17 flex-col">
                  <div class="block_17 flex-col"></div>
                  <div class="block_18 flex-col"></div>
                  <div class="block_19 flex-col"></div>
                </div>
                <div class="text-group_4 flex-col">
                  <span class="text_34">中国人寿健康投资部门副总裁</span>
                  <span class="text_35">原国家卫生健康计划委员会重大疾病处处长</span>
                  <span class="text_36">公司商业模式咨询和渠道建设</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block_20 flex-row">
          <div class="box_18 flex-col">
            <div class="image-wrapper_3 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG9645a6a9b6025270fbb9e8c4809e83c4.png')"
              />
            </div>
          </div>
          <div class="box_19 flex-col">
            <div class="group_23 flex-row justify-between">
              <div class="text-wrapper_5 flex-col"><span class="text_37">郭建军</span></div>
              <span class="text_38">特聘专家</span>
            </div>
            <div class="group_24 flex-row justify-between">
              <div class="section_14 flex-col"></div>
              <div class="section_15 flex-col"></div>
              <span class="text_39">负责公司医疗技术收集和支持，产品市场推广</span>
            </div>
            <div class="group_25 flex-row justify-between">
              <div class="box_20 flex-col"></div>
              <div class="box_21 flex-col"></div>
              <span class="text_40">国家医体整合联盟秘书长，总策划人和执行人</span>
            </div>
            <div class="group_26 flex-row justify-between">
              <div class="box_22 flex-col"></div>
              <div class="box_23 flex-col"></div>
              <span class="text_41">中华预防医学会糖尿病预防与控制专业委员会委员</span>
            </div>
            <div class="group_27 flex-row justify-between">
              <div class="group_28 flex-col"></div>
              <div class="group_29 flex-col"></div>
              <span class="text_42">首都体育学院体医融合中心主任、前国家体育总局体医融合促进与创新研究中心主任</span>
            </div>
            <div class="group_30 flex-row justify-between">
              <div class="group_31 flex-col"></div>
              <div class="group_32 flex-col"></div>
              <span class="text_43">中国康复医学会心血管、呼吸康复专业委员会常委</span>
            </div>
            <div class="group_33 flex-row justify-between">
              <div class="section_16 flex-col"></div>
              <div class="section_17 flex-col"></div>
              <span class="text_44">中国健康促进与教育协会运动与康复分会副主任委员</span>
            </div>
          </div>
        </div>
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd6b436eef2b483e3247bf93be1e553d1.png')"
        />
        <div class="text-wrapper_6 flex-row">
          <span class="paragraph_4">
            负责公司战略方向制定，团队管理，软件产品功能制定。内部运营
            <br />
            及后期医学运营，管理组建公司运
            <br />
            动指导师闲暇团队
          </span>
          <span class="text_45">
            美国注册物理治疗师，中国队游泳队前队医，北京朝阳区凤凰计划海归人才，北京中关村雏鹰人才北京卫视养生堂，健康北京，央视健康之路，央广等栏目的慢病运动指导专家
          </span>
        </div>
      </div>
      <div class="box_24 flex-row">
        <div class="block_21 flex-col"></div>
        <div class="block_22 flex-col"></div>
        <div class="block_23 flex-col"></div>
        <div class="block_24 flex-col"></div>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_7"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_46">合作医院</span>
      </div>
      <div class="box_25 flex-row">
        <div class="image-text_1 flex-col justify-between">
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGa1a9f53942284b3bdc02e9e69cb181e7.png')"
          />
          <span class="text-group_5">北京大学第一医院</span>
        </div>
        <div class="section_18 flex-col justify-between">
          <div class="box_26 flex-col">
            <div class="image-wrapper_4 flex-col">
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG59d351f29ca539417604e455bb4f7d21.png')"
              />
            </div>
          </div>
          <span class="paragraph_5">
            北京医院
            <br />
            （国家老年医学中心）
          </span>
        </div>
        <div class="image-text_2 flex-col justify-between">
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGfc02edf2c2ddb79d91562cebeeb65698.png')"
          />
          <span class="text-group_6">北京大学人民医院</span>
        </div>
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_11"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG54f9e3e5ad494c76b1e2601fb24819a6.png')"
          />
          <span class="text-group_7">
            首都医科大学附属
            <br />
            北京安定医院
          </span>
        </div>
        <div class="image-text_4 flex-col justify-between">
          <img
            class="image_12"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGf9256286f04e49c1617057ceb12b7ff6.png')"
          />
          <span class="text-group_8">
            首都医科大学
            <br />
            北京朝阳医院
          </span>
        </div>
        <div class="image-text_5 flex-col justify-between">
          <img
            class="image_13"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGcf2c915b1cd87f4b48a8059aab2baec4.png')"
          />
          <span class="text-group_9">北京平安医院</span>
        </div>
        <div class="image-text_6 flex-col justify-between">
          <img
            class="image_14"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGcbf84e461ddf92f733231bd1fd49de3f.png')"
          />
          <span class="text-group_10">中日友好医院</span>
        </div>
        <div class="image-text_7 flex-col justify-between">
          <img
            class="image_15"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG6c77a91015d19a9378fe6f70c4cc9956.png')"
          />
          <span class="text-group_11">
            八里庄第二社区
            <br />
            卫生服务中心
          </span>
        </div>
      </div>
      <div class="box_27 flex-row">
        <div class="group_34 flex-col"></div>
        <div class="group_35 flex-col"></div>
        <div class="group_36 flex-col"></div>
        <div class="group_37 flex-col"></div>
        <img
          class="thumbnail_8"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_9"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_10"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_47">合作公司</span>
      </div>
      <div class="image-wrapper_5 flex-row justify-between">
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG70c217648c0e5f024e912dad8c2bba28.png')"
        />
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGa027738f54cb246027fc14d5a3e7e076.png')"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGc726f48a01f4b2e89a5011c71dbe7c36.png')"
        />
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG3be3c9e39172acbfd1517a447540b5fe.png')"
        />
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG51351baf733a2b77435be34c233dbfef.png')"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG2208d344c7584e28d53d9a2b6eab485f.png')"
        />
        <img
          class="image_22"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGa5d7c9c3dc560138a0c8489d1e035347.png')"
        />
      </div>
      <div class="box_28 flex-row">
        <div class="box_29 flex-col"></div>
        <div class="box_30 flex-col"></div>
        <div class="box_31 flex-col"></div>
        <div class="box_32 flex-col"></div>
        <img
          class="thumbnail_11"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_12"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_13"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_48">公司项目覆盖情况</span>
      </div>
      <div class="image-wrapper_6 flex-row">
        <img
          class="image_23"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG77f76164ffac0b0f16b905555e737cb1.png')"
        />
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG81b2d6d9eb5e06b85cd8af3f28f98fb9.png')"
        />
        <img
          class="image_25"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG5159410fc10ca594826b53eb6bbc51dc.png')"
        />
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGc0189645430acca8d357caeabdb4f886.png')"
        />
        <img
          class="image_27"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGb19b3156911d708d7021a7e799ab7148.png')"
        />
        <img
          class="image_28"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGe40066d95348fc239dd2466cc6f106e8.png')"
        />
        <img
          class="image_29"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG251a106a920e59378ceee9ded7ea2c9d.png')"
        />
        <img
          class="image_30"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG7eb12c3aae8f3a98354f4c035fa6a95b.png')"
        />
      </div>
      <div class="text-wrapper_7 flex-row">
        <span class="text_49">深圳招商健康</span>
        <span class="text_50">北京中日友好医院</span>
        <span class="text_51">北京老年医院</span>
        <span class="paragraph_6">
          北京大兴清源路街道
          <br />
          养老社区SMIC
        </span>
        <span class="text_52">北京聚陆医疗</span>
        <span class="paragraph_7">
          北京顺义“妙健康”金茂怡生园
          <br />
          加拿大健康管理中心
        </span>
      </div>
      <div class="box_33 flex-row">
        <div class="group_38 flex-col"></div>
        <div class="group_39 flex-col"></div>
        <div class="group_40 flex-col"></div>
        <div class="group_41 flex-col"></div>
        <img
          class="thumbnail_14"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_15"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_16"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_53">公司项目参赛奖项</span>
      </div>
      <div class="box_34 flex-row">
        <img
          class="image_31"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG01df46cc169a35ea5dca13ba19e98b66.png')"
        />
        <img
          class="image_32"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381eb50fa128c160ccf6417479d3cef7.png')"
        />
        <img
          class="image_33"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG32d2cf1ce35bbc763956c678bf5612fb.png')"
        />
        <img
          class="image_34"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGf0b1130b33efeaafe5a4b5a8204fea88.png')"
        />
        <div class="image-wrapper_7 flex-col">
          <img
            class="image_35"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGbfd74bd93aba47fa6e777d2ce6d9b3d6.png')"
          />
        </div>
      </div>
      <div class="text-wrapper_8 flex-col">
        <span class="text_54">联系方式</span>
        <span class="text_55">contact&nbsp;information</span>
        <span class="text_56">132-2019-0868</span>
        <span class="text_57">北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        <span class="text_58">info&#64;ktangtang.com</span>
        <span class="text_59">https://ktangtang.com</span>
      </div>
    </div>
    <div class="block_25 flex-col">
      <div class="image-wrapper_8 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_36"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG33f935e7aff511ef96bc22348410d09b.png')"
        />
      </div>
      <div class="box_35 flex-row">
        <div class="box_36 flex-col justify-between">
          <div class="text-wrapper_9 flex-row justify-between">
            <span class="text_60">联系方式：13220190868</span>
            <span class="text_61">Email：info&#64;ktangtang.com</span>
          </div>
          <span class="text_62">官网地址：https://ktangtang.com</span>
          <span class="text_63">公司地址：&nbsp;北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        </div>
        <div class="text-wrapper_10 flex-col justify-between">
          <span class="text_64">公众号：以动健康</span>
          <span class="text_65">官方微博：&#64;以动健康</span>
          <span class="text_66">京ICP备19026627号</span>
        </div>
        <div class="image-text_8 flex-col justify-between">
          <img
            class="image_37"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.png')"
          />
          <span class="text-group_12">公众号二维码</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />